import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastService } from '@siemens/ix-angular';
import { environment } from 'src/environments/environment';
import { Project } from '../models/project.model';
import { saveAs } from '../utils/file-download.util';

@Injectable({
  providedIn: 'root'
})
export class FileTransferService {
  constructor(
    private readonly httpService: HttpClient,
    private readonly toastService: ToastService
  ) {}

  async downloadFile(fileType: string, project?: Project) {
    let endpoint = '';
    if (fileType === 'Masterfile') {
      endpoint = environment.baseUrl + '/calculation-file/masterfile/download';
    } else if (fileType === 'Project' && project !== null && project !== undefined) {
      endpoint = environment.baseUrl + `/calculation-file/download/${project.id}`;
    } else {
      // andere filetypen implementieren, Bis dahin return
      return;
    }

    const options = {
      headers: new HttpHeaders({
        accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      }),
      responseType: 'blob' as const,
      observe: 'body' as const
    };

    this.httpService.get(endpoint, options).subscribe(
      blob => {
        let fileName = '';
        if (project !== null && project !== undefined) {
          const sanitizedProjectName = this.sanitizeProjectName(project.name);
          fileName = `${fileType}_${sanitizedProjectName}.xlsx`;
        } else {
          fileName = `${fileType}.xlsx`;
        }

        saveAs(blob, fileName);
      },
      (errorResponse: HttpErrorResponse) => {
        const details = errorResponse.message || '';
        this.toastService.show({
          title: 'Download error',
          message: 'We cannot download the file from the server. Try again. ' + details,
          type: 'error'
        });
      }
    );
  }

  private sanitizeProjectName(projectName: string) {
    const maxProjectNameLength = 200;
    let sanitizedProjectName = projectName.replace(/[^a-zA-Z0-9_\-\. ]/g, '').trim();
    if (sanitizedProjectName.length > maxProjectNameLength) {
      sanitizedProjectName = sanitizedProjectName.slice(0, maxProjectNameLength);
    }
    return sanitizedProjectName;
  }

  async uploadFile(fileType: string, file: File, id?: string) {
    return new Promise((resolve, reject) => {
      let endpoint = '';

      if (fileType === 'Masterfile') {
        endpoint = environment.baseUrl + '/calculation-file/masterfile/upload';
      } else if (fileType === 'Project') {
        endpoint = environment.baseUrl + `/calculation-file/masterfile/upload/${id}`;
      } else {
        return reject(new Error('Unsupported fileType'));
      }
      const formData: FormData = new FormData();
      formData.append('file', file);

      const options = {
        observe: 'response' as const
      };

      this.httpService.post(endpoint, formData, options).subscribe(
        () => resolve(true),
        (errorResponse: HttpErrorResponse) => {
          const details = errorResponse.message || '';
          this.toastService.show({
            title: 'Upload error',
            message: 'We cannot upload the file to the server. Try again. ' + details,
            type: 'error'
          });

          return reject();
        }
      );
    });
  }
}
